import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.monkey = bracketIndenting({
	line: "'",
})
